import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import { guidFor } from '@ember/object/internals';
import { debug } from '@ember/debug';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\"input-tel-wrap\" {{did-insert this.onInsert}} {{did-update this.onValueChange @value}}>\n  <input\n    id={{this.inputId}}\n    type=\'tel\'\n    disabled={{@disabled}}\n    name={{@name}}\n    placeholder={{@placeholder}}\n    required={{@required}}\n    autocomplete=\'off\'\n    aria-invalid={{if (or this.errorMsg @error) \"true\"}}\n    aria-describedby={{if (or this.errorMsg @error) (concat this.inputId \"-error\")}}\n    class=\'{{if this.errorMsg \"error\"}} {{if @error \"error\"}}\'\n    {{on \'input\' (perform this.handleChangeTask)}}\n    {{on \'countrychange\' (perform this.handleChangeTask)}}\n    {{on \'focusout\' this.focusOut}}\n  />\n\n  {{#if (or this.errorMsg @error)}}\n    <span id={{concat this.inputId \"-error\"}} role=\"alert\" class=\'input-definition text-alert\'>\n      {{or this.errorMsg @error}}\n    </span>\n  {{/if}}\n</div>\n");

var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
const _assetCache = {};
function _loadAsset(tag, attr, url) {
  if (_assetCache[url]) return _assetCache[url];
  _assetCache[url] = new Promise((resolve, reject) => {
    // Controlla se l'elemento esiste già E è stato caricato
    const existing = document.querySelector(`${tag}[${attr}="${url}"]`);
    if (existing) {
      // Risolvi subito solo se l'asset è davvero pronto: foglio di stile
      // applicato, oppure script già valutato (global disponibile). Un tag
      // <script> presente ma ancora in-flight NON ha eseguito: attendere il
      // load, altrimenti initTelTask chiamerebbe una funzione undefined.
      if (tag === 'link' && existing.sheet) {
        resolve();
        return;
      }
      if (tag === 'script' && window.intlTelInput) {
        resolve();
        return;
      }
      // Altrimenti attendi il caricamento in corso
      existing.addEventListener('load', resolve, {
        once: true
      });
      existing.addEventListener('error', () => {
        // Rimuovi dalla cache così un retry futuro può riprovare
        delete _assetCache[url];
        reject(new Error(`Failed to load ${url}`));
      }, {
        once: true
      });
      return;
    }
    const el = document.createElement(tag);
    if (tag === 'link') {
      el.rel = 'stylesheet';
      el.href = url;
    } else {
      el.src = url;
    }
    el.onload = resolve;
    el.onerror = () => {
      // Rimuovi dalla cache così un retry futuro può riprovare
      delete _assetCache[url];
      reject(new Error(`Failed to load ${url}`));
    };
    document.head.appendChild(el);
  });
  return _assetCache[url];
}
let BbInputTelComponent = (_dec = task(function* () {
  try {
    const cssUrl = `${this.pluginUrl}/css/intlTelInput.css`;
    const jsUrl = `${this.pluginUrl}/js/intlTelInput.min.js`;
    yield _loadAsset('link', 'href', cssUrl);
    if (this.isDestroying || this.isDestroyed) return;
    if (typeof window.intlTelInput !== 'function') {
      yield _loadAsset('script', 'src', jsUrl);
      if (this.isDestroying || this.isDestroyed) return;
    }
    yield this.initTelTask.perform();
  } catch {
    if (this.isDestroying || this.isDestroyed) return;
    this.errorMsg = this.intl.t('comunication error');
  }
}).drop(), _dec2 = task(function* (intlTel) {
  if (!intlTel) return;
  let data = this.session.ipLocation;
  if (data) {
    intlTel.setCountry(data.country_code || 'it');
    return;
  }
  try {
    const response = yield fetch('https://ipapi.co/json');
    if (this.isDestroying || this.isDestroyed) return;
    data = yield response.json();
    if (this.isDestroying || this.isDestroyed) return;
    this.session.setIpLocation(data);
    intlTel.setCountry(data.country_code || 'it');
  } catch {
    if (this.isDestroying || this.isDestroyed) return;
    intlTel.setCountry('it');
  }
}).drop(), _dec3 = task(function* () {
  let input = document.querySelector(`#${this.inputId}`);
  if (!input) {
    let retryCount = 0;
    while (!input && retryCount < 5) {
      yield timeout(100);
      if (this.isDestroying || this.isDestroyed) return;
      input = document.querySelector(`#${this.inputId}`);
      retryCount++;
    }
    if (!input) {
      debug("BbInputTelComponent: impossibile trovare l'elemento input dopo 5 tentativi.");
      return;
    }
  }
  const intlTel = window.intlTelInput(input, {
    utilsScript: `${this.pluginUrl}/js/utils.js?1695806485509`,
    // [prod-fix] — 'FIXED_LINE' rifiutava numeri mobili US e altri paesi dove il NANP
    // non distingue fisso/mobile; MOBILE è il tipo più comune per input utente
    numberType: 'MOBILE'
  });
  this.intlTel = intlTel;
  yield timeout(50);
  if (this.isDestroying || this.isDestroyed) return;
  if (this.args.value && this.args.value !== '') {
    intlTel.setNumber(this.args.value);
  } else {
    this.setInitCountryTask.perform(intlTel);
  }
  yield timeout(100);
  if (this.isDestroying || this.isDestroyed) return;
  this._handleChange();
}).drop(), _dec4 = task(function* () {
  yield timeout(50);
  if (this.isDestroying || this.isDestroyed) return;
  this._handleChange();
}).restartable(), _class = class BbInputTelComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "intlTel", _descriptor3, this);
    _initializerDefineProperty(this, "errorMsg", _descriptor4, this);
    _initializerDefineProperty(this, "isValid", _descriptor5, this);
    this.pluginUrl = 'https://beebeeassets.beebeeboard.com/assets/intl-tel-input/18.2.1/build';
    this.errorMap = ['tel.invalid_number', 'tel.invalid_country_code', 'tel.too_short', 'tel.too_long'];
    // ─── Tasks ───────────────────────────────────────────────────────────────────
    _initializerDefineProperty(this, "initTask", _descriptor6, this);
    _initializerDefineProperty(this, "setInitCountryTask", _descriptor7, this);
    _initializerDefineProperty(this, "initTelTask", _descriptor8, this);
    _initializerDefineProperty(this, "handleChangeTask", _descriptor9, this);
  }
  get inputId() {
    return `input-tel-${guidFor(this)}`;
  }

  // ─── Lifecycle ───────────────────────────────────────────────────────────────

  onInsert() {
    this.initTask.perform();
  }
  willDestroy() {
    // [regression-fix] CAT-5 — duplicate super.willDestroy() call removed
    super.willDestroy(...arguments);
    this.intlTel?.destroy();
  }
  // ─── Handlers ────────────────────────────────────────────────────────────────

  // ─── Sync @value esterno → widget ───────────────────────────────────────────

  onValueChange() {
    if (!this.intlTel) return;
    const newValue = this.args.value ?? '';
    const current = this.intlTel.getNumber();
    if (newValue !== current) {
      this.intlTel.setNumber(newValue);
      this._handleChange();
    }
  }
  focusOut() {
    this._handleChange();
    this.args.focusOutAction?.();
  }

  // Validazione di base quando intl-tel-input non è disponibile o utils.js non è caricato
  _basicPhoneValidation(number) {
    const cleaned = number.replace(/[\s\-().]/g, '');
    // E.164: da 7 a 15 cifre, opzionalmente precedute da +
    return /^\+?\d{7,15}$/.test(cleaned);
  }
  _handleChange() {
    this.errorMsg = null;

    // ── Fallback: intl-tel-input non caricato ──────────────────────────────────
    if (!this.intlTel) {
      const input = document.querySelector(`#${this.inputId}`);
      const number = input?.value?.trim() || '';
      this.args.onChange?.(number);
      if (!number) {
        this.args.onValidChange?.(false);
        return;
      }
      const isValid = this._basicPhoneValidation(number);
      this.isValid = isValid;
      this.args.onValidChange?.(isValid);
      if (!isValid) {
        this.errorMsg = this.intl.t(this.errorMap[0]);
      }
      return;
    }
    const number = this.intlTel.getNumber();

    // Notifica il parent del nuovo valore (DDAU)
    this.args.onChange?.(number);
    if (!number || number === '') {
      this.args.onValidChange?.(false);
      return;
    }
    const isValid = this.intlTel.isValidNumber();

    // ── Fallback: utils.js non caricato (isValidNumber ritorna null) ───────────
    if (isValid === null) {
      const fallbackValid = this._basicPhoneValidation(number);
      this.isValid = fallbackValid;
      this.args.onValidChange?.(fallbackValid);
      if (!fallbackValid) {
        this.errorMsg = this.intl.t(this.errorMap[0]);
      }
      return;
    }
    this.isValid = isValid;

    // Propaga lo stato di validazione al parent
    this.args.onValidChange?.(isValid);
    if (!isValid) {
      let error = this.intlTel.getValidationError();
      if (![0, 1, 2, 3].includes(error)) error = 0;
      this.errorMsg = this.intl.t(this.errorMap[error]);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intlTel", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errorMsg", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isValid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "initTask", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "setInitCountryTask", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "initTelTask", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "handleChangeTask", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusOut"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbInputTelComponent);

export { BbInputTelComponent as default };
//# sourceMappingURL=bb-input-tel.js.map
